/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

import { MASSACHUSETTS } from './States';
import { GenderSportEnum } from 'queries';

export const BOYS_BASKETBALL = 'basketball';
export const GIRLS_BASKETBALL = 'girls-basketball';
export const FOOTBALL = 'football';
export const BASEBALL = 'baseball';
export const SOFTBALL = 'softball';
export const BOYS_LACROSSE = 'lacrosse';
export const GIRLS_LACROSSE = 'girls-lacrosse';
export const BOYS_SOCCER = 'soccer';
export const GIRLS_SOCCER = 'girls-soccer';
export const BOYS_VOLLEYBALL = 'boys-volleyball';
export const GIRLS_VOLLEYBALL = 'volleyball';
export const BOYS_FIELD_HOCKEY = 'boys-field-hockey';
export const FIELD_HOCKEY = 'field-hockey';
export const BOYS_ICE_HOCKEY = 'ice-hockey';
export const GIRLS_ICE_HOCKEY = 'girls-ice-hockey';
export const BOYS_WATER_POLO = 'water-polo';
export const GIRLS_WATER_POLO = 'girls-water-polo';
export const BOYS_CROSS_COUNTRY = 'cross-country';
export const GIRLS_CROSS_COUNTRY = 'girls-cross-country';
export const BOYS_GOLF = 'golf';
export const GIRLS_GOLF = 'girls-golf';
export const BOYS_TENNIS = 'tennis';
export const GIRLS_TENNIS = 'girls-tennis';
export const WRESTLING = 'wrestling';
export const GIRLS_WRESTLING = 'girls-wrestling';
export const BEACH_VOLLEYBALL = 'beach-volleyball';
export const FLAG_FOOTBALL = 'flag-football';
export const UNIFIED_BASKETBALL = 'unified-basketball';
export const BOYS_ULTIMATE_FRISBEE = 'boys-ultimate-frisbee';
export const GIRLS_ULTIMATE_FRISBEE = 'girls-ultimate-frisbee';
export const BOYS_FENCING = 'boys-fencing';
export const GIRLS_FENCING = 'girls-fencing';
export const BADMINTON = 'badminton';
export const BOYS_TRACK_AND_FIELD = 'boys-track-and-field';
export const GIRLS_TRACK_AND_FIELD = 'girls-track-and-field';
export const GIRLS_GYMNASTICS = 'girls-gymnastics';

export type GenderSportType = ConstantsQuery['genderSports'][number];

const GENDER_SPORTS: GenderSportType[] = [
  {
    slug: BOYS_BASKETBALL,
    name: 'Boys Basketball',
    sportId: 1,
    genderId: 1,
    key: GenderSportEnum.BOYS_BASKETBALL
  },
  {
    slug: GIRLS_BASKETBALL,
    name: 'Girls Basketball',
    sportId: 1,
    genderId: 2,
    key: GenderSportEnum.GIRLS_BASKETBALL
  },
  {
    slug: FOOTBALL,
    name: 'Football',
    sportId: 2,
    genderId: 1,
    key: GenderSportEnum.FOOTBALL
  },
  {
    slug: BASEBALL,
    name: 'Baseball',
    sportId: 3,
    genderId: 1,
    key: GenderSportEnum.BASEBALL
  },
  {
    slug: SOFTBALL,
    name: 'Softball',
    sportId: 4,
    genderId: 2,
    key: GenderSportEnum.SOFTBALL
  },
  {
    slug: BOYS_LACROSSE,
    name: 'Boys Lacrosse',
    sportId: 5,
    genderId: 1,
    key: GenderSportEnum.BOYS_LACROSSE
  },
  {
    slug: GIRLS_LACROSSE,
    name: 'Girls Lacrosse',
    sportId: 5,
    genderId: 2,
    key: GenderSportEnum.GIRLS_LACROSSE
  },
  {
    slug: BOYS_SOCCER,
    name: 'Boys Soccer',
    sportId: 6,
    genderId: 1,
    key: GenderSportEnum.BOYS_SOCCER
  },
  {
    slug: GIRLS_SOCCER,
    name: 'Girls Soccer',
    sportId: 6,
    genderId: 2,
    key: GenderSportEnum.GIRLS_SOCCER
  },
  {
    slug: BOYS_VOLLEYBALL,
    name: 'Boys Volleyball',
    sportId: 7,
    genderId: 1,
    key: GenderSportEnum.BOYS_VOLLEYBALL
  },
  {
    slug: GIRLS_VOLLEYBALL,
    name: 'Girls Volleyball',
    sportId: 7,
    genderId: 2,
    key: GenderSportEnum.GIRLS_VOLLEYBALL
  },
  {
    slug: BOYS_FIELD_HOCKEY,
    name: 'Boys Field Hockey',
    sportId: 8,
    genderId: 1,
    key: GenderSportEnum.BOYS_FIELD_HOCKEY
  },
  {
    slug: FIELD_HOCKEY,
    name: 'Field Hockey',
    sportId: 8,
    genderId: 2,
    key: GenderSportEnum.FIELD_HOCKEY
  },
  {
    slug: BOYS_ICE_HOCKEY,
    name: 'Boys Ice Hockey',
    sportId: 9,
    genderId: 1,
    key: GenderSportEnum.BOYS_ICE_HOCKEY
  },
  {
    slug: GIRLS_ICE_HOCKEY,
    name: 'Girls Ice Hockey',
    sportId: 9,
    genderId: 2,
    key: GenderSportEnum.GIRLS_ICE_HOCKEY
  },
  {
    slug: BOYS_WATER_POLO,
    name: 'Boys Water Polo',
    sportId: 10,
    genderId: 1,
    key: GenderSportEnum.BOYS_WATER_POLO
  },
  {
    slug: GIRLS_WATER_POLO,
    name: 'Girls Water Polo',
    sportId: 10,
    genderId: 2,
    key: GenderSportEnum.GIRLS_WATER_POLO
  },
  {
    slug: BOYS_CROSS_COUNTRY,
    name: 'Boys Cross Country',
    sportId: 11,
    genderId: 1,
    key: GenderSportEnum.BOYS_CROSS_COUNTRY
  },
  {
    slug: GIRLS_CROSS_COUNTRY,
    name: 'Girls Cross Country',
    sportId: 11,
    genderId: 2,
    key: GenderSportEnum.GIRLS_CROSS_COUNTRY
  },
  {
    slug: BOYS_GOLF,
    name: 'Boys Golf',
    sportId: 12,
    genderId: 1,
    key: GenderSportEnum.BOYS_GOLF
  },
  {
    slug: GIRLS_GOLF,
    name: 'Girls Golf',
    sportId: 12,
    genderId: 2,
    key: GenderSportEnum.GIRLS_GOLF
  },
  {
    slug: BOYS_TENNIS,
    name: 'Boys Tennis',
    sportId: 13,
    genderId: 1,
    key: GenderSportEnum.BOYS_TENNIS
  },
  {
    slug: GIRLS_TENNIS,
    name: 'Girls Tennis',
    sportId: 13,
    genderId: 2,
    key: GenderSportEnum.GIRLS_TENNIS
  },
  {
    slug: WRESTLING,
    name: 'Wrestling',
    sportId: 14,
    genderId: 1,
    key: GenderSportEnum.WRESTLING
  },
  {
    slug: GIRLS_WRESTLING,
    name: 'Girls Wrestling',
    sportId: 14,
    genderId: 2,
    key: GenderSportEnum.GIRLS_WRESTLING
  },
  {
    slug: BEACH_VOLLEYBALL,
    name: 'Beach Volleyball',
    sportId: 15,
    genderId: 2,
    key: GenderSportEnum.BEACH_VOLLEYBALL
  },
  {
    slug: FLAG_FOOTBALL,
    name: 'Flag Football',
    sportId: 16,
    genderId: 2,
    key: GenderSportEnum.FLAG_FOOTBALL
  },
  {
    slug: UNIFIED_BASKETBALL,
    name: 'Unified Basketball',
    sportId: 17,
    genderId: 3,
    key: GenderSportEnum.UNIFIED_BASKETBALL
  },
  {
    slug: BOYS_ULTIMATE_FRISBEE,
    name: 'Boys Ultimate Frisbee',
    sportId: 18,
    genderId: 1,
    key: GenderSportEnum.BOYS_ULTIMATE_FRISBEE
  },
  {
    slug: GIRLS_ULTIMATE_FRISBEE,
    name: 'Girls Ultimate Frisbee',
    sportId: 18,
    genderId: 2,
    key: GenderSportEnum.GIRLS_ULTIMATE_FRISBEE
  },
  {
    slug: BOYS_FENCING,
    name: 'Boys Fencing',
    sportId: 19,
    genderId: 1,
    key: GenderSportEnum.BOYS_FENCING
  },
  {
    slug: GIRLS_FENCING,
    name: 'Girls Fencing',
    sportId: 19,
    genderId: 2,
    key: GenderSportEnum.GIRLS_FENCING
  },
  {
    slug: BADMINTON,
    name: 'Badminton',
    sportId: 20,
    genderId: 3,
    key: GenderSportEnum.BADMINTON
  },
  {
    slug: BOYS_TRACK_AND_FIELD,
    name: 'Boys Track And Field',
    sportId: 21,
    genderId: 1,
    key: GenderSportEnum.BOYS_TRACK_AND_FIELD
  },
  {
    slug: GIRLS_TRACK_AND_FIELD,
    name: 'Girls Track And Field',
    sportId: 21,
    genderId: 2,
    key: GenderSportEnum.GIRLS_TRACK_AND_FIELD
  },
  {
    slug: GIRLS_GYMNASTICS,
    name: 'Girls Gymnastics',
    sportId: 22,
    genderId: 2,
    key: GenderSportEnum.GIRLS_GYMNASTICS
  }
];

export function findGenderSport(sportId?: number, genderId?: number) {
  return GENDER_SPORTS.find(genderSport => genderSport.sportId === sportId && genderSport.genderId === genderId);
}

export function findGenderSportBySlug(genderSportSlug?: string) {
  return GENDER_SPORTS.find(genderSport => genderSport.slug === genderSportSlug);
}

export function genderSportsByState(stateAbbrev?: string) {
  if (stateAbbrev == MASSACHUSETTS) {
    return GENDER_SPORTS;
  } else {
    return GENDER_SPORTS.filter(genderSport => genderSport.slug != BOYS_FIELD_HOCKEY);
  }
}

export default GENDER_SPORTS;
